import { differenceInCalendarMonths } from 'date-fns'
import { currency, date, parseDate } from 'helpers/format'

// Constants
import { BANK, DEPOSIT, GCASH } from 'models/Payment'
export const ACTIVE = 'Active'
export const ACTIVE_LABEL = 'Active'
export const ACTIVE_COLOR = '#2F9BAA'
export const INACTIVE = 'Inactive'
export const INACTIVE_LABEL = 'Inactive'
export const INACTIVE_COLOR = '#FA6383'

// Models
import Model from 'models/Model'

export default class Contract extends Model {
  get id() {
    return this.model.id
  }

  get contractNumber() {
    return this.model.contractNumber
  }

  get lessorName() {
    return this.model.name
  }

  get vendorCode() {
    return this.model.vendorCode
  }

  get contractStart() {
    return date(this.model.contractStartDate, 'MMM dd, yyyy')
  }

  get contractEnd() {
    return date(this.model.endOfTerm, 'MMM dd, yyyy')
  }

  get contractPeriod() {
    return this.model.secondSignature
      ? `${date(this.model.secondSignature, 'MMM dd, yyyy')} - ${date(
          this.model.endOfTerm,
          'MMM dd, yyyy'
        )}`
      : ''
  }

  get status() {
    if (this.model.status === ACTIVE) {
      return ACTIVE_LABEL
    }

    if (this.model.status === INACTIVE) {
      return INACTIVE_LABEL
    }

    return this.model.status
  }

  get statusColor() {
    if (this.model.status === ACTIVE) {
      return ACTIVE_COLOR
    }

    if (this.model.status === INACTIVE) {
      return INACTIVE_COLOR
    }

    return '#606060'
  }

  get paymentRate() {
    return currency(this.model.paymentRate)
  }

  get paymentMethod() {
    if (DEPOSIT.includes(this.model.paymentMethod)) {
      return 'Cheque Deposit'
    }

    if (BANK.includes(this.model.paymentMethod)) {
      return 'Bank Transfer'
    }

    if (GCASH.includes(this.model.paymentMethod)) {
      return 'GCash'
    }

    return this.model.paymentMethod
  }

  get businessPartnerCode() {
    return this.model.businessPartnerCode
  }

  get companyCode() {
    return this.model.companyCode
  }

  get securityDeposit() {
    return this.model.securityDeposit
  }

  get paymentTerm() {
    const months = differenceInCalendarMonths(
      parseDate(this.model.termFrom),
      parseDate(this.model.termTo)
    )

    if (isNaN(months)) {
      return 'N/A'
    }

    if (Math.abs(months) <= 1) {
      return 'Monthly'
    }

    if (Math.abs(months) <= 3) {
      return 'Quarterly'
    }

    if (Math.abs(months) <= 6) {
      return 'Semi-annual'
    }

    return 'Annually'
  }
}
